import { useState } from "react";
import { DatePicker, DayOfWeek, defaultDatePickerStrings } from "@fluentui/react";
import styles from "./DatePickerCard.module.css";

interface DatePickerCardProps {
    packageName: string;
    onDateSelect?: (packageName: string, dateStr: string) => void;
}

const formatDate = (date: Date): string => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
};

const formatDisplayDate = (date: Date): string => {
    return date.toLocaleDateString("en-US", {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
    });
};

export const DatePickerCard = ({ packageName, onDateSelect }: DatePickerCardProps) => {
    const [selectedDate, setSelectedDate] = useState<Date | undefined>(undefined);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const handleSelectDate = (date: Date | null | undefined) => {
        if (date) {
            setSelectedDate(date);
        }
    };

    const handleConfirm = () => {
        if (selectedDate && onDateSelect) {
            onDateSelect(packageName, formatDate(selectedDate));
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>Select a date for {packageName}</div>
            <div className={styles.pickerWrapper}>
                <DatePicker
                    firstDayOfWeek={DayOfWeek.Sunday}
                    placeholder="Select a date..."
                    strings={defaultDatePickerStrings}
                    value={selectedDate}
                    onSelectDate={handleSelectDate}
                    minDate={today}
                    showGoToToday={false}
                />
            </div>
            {selectedDate && (
                <div className={styles.footer}>
                    <span className={styles.selectedLabel}>
                        {formatDisplayDate(selectedDate)}
                    </span>
                    <button
                        className={styles.confirmButton}
                        onClick={handleConfirm}
                    >
                        Check Availability
                    </button>
                </div>
            )}
        </div>
    );
};
